import { applyMiddleware, compose, createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import reducer from './reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// redux-persist setup
const persistConfig = {
  key: 'psap_management',
  storage,
  stateReconciler: autoMergeLevel2,
  blacklist: ['psaps'],
};
const pReducer = persistReducer(persistConfig, reducer);
export const store = createStore(
  pReducer,
  composeEnhancers(applyMiddleware(thunk)),
);
export const persistor = persistStore(store);
